import React from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

class SuperAdminContainer extends AuthorizedComponent {

    constructor(props) {
        super(props);
        //this.userRoles = [this.props.UserDetails.loginData.data.facilities[0].facility ? this.props.UserDetails.selectedUserRoleID : this.props.UserDetails.loginData.data.facilities[0].role.id];
        this.userRoles =  [this.props.UserDetails.selectedUserRoleID] ;
        this.notAuthorizedPath = '/';
    }

    //   handleUnauthorizedRole(routeRoles, userRoles){
    //     // handle unsuccessful authorization somehow
    //     console.log(`Route is available for roles: ${routeRoles}, but your roles are: ${userRoles}...`);

    //     // you should still redirect somewhere else if you want to prevent from accessing the restricted route ...
    //     // ... or just use the default behaviour by calling `super.handleUnauthorizedRole()`
    //     const { router } = this.context;
    //     router.push('/');
    //   }

    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}

//export default SuperAdminContainer;

let mapStateToProps = (state) => {

    // Redirection of Urll pasting
    var loginDetails;
    if (!state.User.loginData) {
        loginDetails = {
            data: {
                role: {
                    name: "Dummy"
                }
            }
        };
    }
    return {
      UserDetails: state.User || loginDetails,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});

export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(SuperAdminContainer));



/** WEBPACK FOOTER **
 ** ./src/components/superAdminContainer.js
 **/